
import { DOMESTIC, INTERNATIONAL } from '../../constants';
export const checkGeographicType = (geographicType) => {
    if (geographicType) {
        if (geographicType.values) {
            if (geographicType.values.geographicType === DOMESTIC) {
                return DOMESTIC
            } else if (geographicType.values.geographicType === INTERNATIONAL) {
                return INTERNATIONAL
            }
        }
    }
}

export const createRequestBody = (formValues, geographicType) => {
    let tempRequestBody = null;
    let tempCountry = {
        sortname: formValues.country.id,
        name: formValues.country.value
    }
    let tempState=null
    if (geographicType === DOMESTIC) {
        tempState = formValues.state.value
        tempRequestBody = {
            ...formValues,
            state: tempState,
            country: tempCountry
        }
    } else {
        if(formValues.state && formValues.state.value){
        tempState = formValues.state.value
    }
        tempRequestBody = {
            ...formValues,
            gstNo: null,
            panNo: null,
            cinNumber:null,
            pinCode: null,
            state: tempState,
            country: tempCountry
        }
    }
    return tempRequestBody
}